import React from 'react';

export const Icon = ({ icon, small = false, level = 'default', size = null, className = '', ...other }) => {
  if(small && !size) {
    size = 'sm';
  }

  const sizes = {
    'sm': 'zoom-75',
    'lg': 'h2 m-0',
    'xl': 'h1 m-0',
  }

  const sizeClass = size ? (sizes[size] || '') : '';

  return (
    <i className={`material-icons align-middle text-${level} ${sizeClass} ${className}`} {...other}>
      {icon}
    </i>
  );
}
